import {FC} from 'react';
import {FeedbackCenter} from './FeedbackCenter';
import {MiddleTopBarUnit} from '../Unit/MiddleTopBarUnit';
import {useUnit} from '../Unit/useUnit';
import {Spinner} from '@fluentui/react';

export const MyFeedbackCenter: FC = () => {
  const {unitId: unitIdFromHook, isLoading, publishedProcessesForUnit, unitPermissions} = useUnit();

  return (
        <main className={`noPaddingTop`}>
      {isLoading ? (
        <Spinner />
      ) : (
        <div>
          <MiddleTopBarUnit
            unitId={unitIdFromHook}
            publishedData={publishedProcessesForUnit?.result}
            unitPermissions={unitPermissions}
            showManage
            />
          <FeedbackCenter isMyFeedback={true} unitId={unitIdFromHook} />
          </div>
        )}

        </main>
  );
};
